import {
  BarChart3, ClipboardList, Hammer, Syringe, ScrollText, Palette, QrCode, Power, Users, Layers, History, KeyRound, ToggleRight,
} from "lucide-react";

export const MODULES = [
  { key: "reports", label: "Laporan & Statistik" },
  { key: "orders", label: "Transaksi Top-Up" },
  { key: "buybacks", label: "Request Bongkar" },
  { key: "inject", label: "Inject Manual" },
  { key: "history", label: "Riwayat & Export" },
  { key: "appearance", label: "Tampilan & Harga Chip" },
  { key: "settings", label: "Pengaturan Situs (QRIS, WA, SEO)" },
  { key: "maintenance", label: "Mode Maintenance" },
];

export const KAPTEN_POWERS = [
  { key: "edit_members", label: "Ubah data anggota" },
  { key: "reset_password", label: "Reset password anggota" },
  { key: "toggle_status", label: "Aktif / nonaktifkan anggota" },
  { key: "set_permissions", label: "Atur hak akses menu anggota" },
];

export const ROLE_LABEL = { master: "MASTER", kapten: "KAPTEN", anggota: "ANGGOTA" };
export const ROLE_CLS = {
  master: "bg-[#e5b80b] text-black",
  kapten: "bg-sky-500/15 text-sky-300 border border-sky-500/40",
  anggota: "bg-white/5 text-zinc-300 border border-white/10",
};

export const emptyPermissions = () =>
  Object.fromEntries(MODULES.map((m) => [m.key, { view: false, manage: false }]));

const isStaffManager = (u) => u?.role === "master" || u?.role === "kapten";
const isMaster = (u) => u?.role === "master";

export const MENUS = [
  { key: "ringkasan", label: "Dashboard Analitik", icon: BarChart3, allowed: (u, can) => can("reports") },
  { key: "transaksi", label: "Transaksi Top-Up", icon: ClipboardList, allowed: (u, can) => can("orders") },
  { key: "bongkar", label: "Request Bongkar", icon: Hammer, allowed: (u, can) => can("buybacks") },
  { key: "inject", label: "Inject Manual", icon: Syringe, allowed: (u, can) => can("inject", "manage") },
  { key: "riwayat", label: "Riwayat Transaksi", icon: ScrollText, allowed: (u, can) => can("history") },
  { key: "tampilan", label: "Tampilan & Harga", icon: Palette, allowed: (u, can) => can("appearance") },
  { key: "pengaturan", label: "Pengaturan Situs", icon: QrCode, allowed: (u, can) => can("settings") },
  { key: "game-popup", label: "Status Game & Popup", icon: ToggleRight, allowed: (u, can) => can("settings") },
  { key: "maintenance", label: "Maintenance", icon: Power, allowed: (u, can) => can("maintenance") },
  { key: "akun", label: "Kelola Akun", icon: Users, allowed: (u) => isStaffManager(u) },
  { key: "bagian", label: "Bagian & Hak Akses", icon: Layers, allowed: (u) => isMaster(u) },
  { key: "aktivitas", label: "Riwayat Aktivitas", icon: History, allowed: (u) => isMaster(u) },
  { key: "akun-saya", label: "Akun Saya", icon: KeyRound, allowed: () => true },
];
